import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ConsolidatedCommissionSelectCtrl implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  accountId: string;
  statuses: string;
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  private consolidatedCommissionsRef: any;
  public selectedConsolidatedCommission: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $consolidatedCommission, private $element) {
    this.consolidatedCommissionsRef = this.$consolidatedCommission();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())
      || (changes.branchIds && !changes.branchIds.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const accountIdRef = this.accountId;
    const statusesRef = this.statuses;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'consolidated-commission';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          accountId: accountIdRef,
          statuses: statusesRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({consolidatedCommission: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const consolidatedCommission = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({consolidatedCommission: consolidatedCommission, id: selectedId});
            panel.destroy();
          } else {
            this.consolidatedCommissionsRef.$asyncValues([selectedId])
              .then((consolidatedCommissions) => {
                this.onChange({consolidatedCommission: consolidatedCommissions[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({consolidatedCommission: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedConsolidatedCommission = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.consolidatedCommissionsRef.$asyncValues([this.selectedId])
          .then((consolidatedCommissions) => {
            this.selectedConsolidatedCommission = consolidatedCommissions[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedConsolidatedCommission = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedConsolidatedCommission, 'name') ||
      _.get(this.selectedConsolidatedCommission, 'id', '');
  }


}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      accountId: '<?',
      statuses: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./consolidated-commission-select.html').default,
    controller: ConsolidatedCommissionSelectCtrl
  });
